module.exports = __webpack_public_path__ + "static/jumbotron-1-e994bae0f6c9f9cd73b12e9dbfa272a4.jpg";